import FormattedMessage from 'I18n/components/FormattedMessage';
import { useSignupEmbedder } from 'signup-embedder/hooks/useSignupEmbedder';
import { Step } from 'signup-constants/Step';
import { devices } from 'signup-constants/styles/viewports.styles';
import styled from 'foundations-theming/utils';
import { getFlowKey } from '../routing/getFlowKey';
import { isSoftwareSignup } from '../store/flow/selectors';
import { OptionalFormattedMessage } from '../views-components/OptionalFormattedMessage';
import { getLandingPageTitle } from './getLandingPageText';
import { Flex } from 'foundations-components/components/Flex';
import { useLayoutTemplate } from '../hooks/useLayoutTemplate';
import { LayoutType } from 'signup-components/types';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const StyledH1 = styled.h1.withConfig({
  displayName: "LandingPageTitle__StyledH1"
})(({
  theme,
  isEmbedded
}) => {
  return {
    fontSize: isEmbedded ? theme.typography['body-700'].fontSize : theme.typography['heading-600'].fontSize,
    textAlign: 'center',
    marginTop: theme.space['0'],
    [`@media ${devices.tablet}`]: {
      marginTop: theme.space['1000']
    },
    [`@media ${devices.desktop}`]: {
      marginTop: theme.space['0']
    }
  };
});
export const LandingPageTitle = ({
  isMobile,
  isSU0004Variation = false
}) => {
  const flowKey = getFlowKey();
  const {
    title,
    subtitleLabel
  } = getLandingPageTitle(flowKey);
  const {
    isActive: isEmbedded
  } = useSignupEmbedder();
  const {
    layoutType
  } = useLayoutTemplate();
  const defaultMobileSubtitle = `views.${Step.LandingPage}.mobileSubtitle.default`;
  const getSubtitle = () => {
    return isMobile && isSoftwareSignup() ? defaultMobileSubtitle : subtitleLabel;
  };
  if (isSU0004Variation) {
    return /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexDirection: "column",
      gap: "200",
      justifyContent: "center",
      marginBlockEnd: "500",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h1",
        textAlign: "center",
        typography: "heading-400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `views.${Step.LandingPage}.SU0004.title`
        })
      }), /*#__PURE__*/_jsx(Text, {
        color: "text-core-subtle",
        textAlign: "center",
        typography: "body-200",
        children: /*#__PURE__*/_jsx(OptionalFormattedMessage, {
          message: getSubtitle()
        })
      })]
    });
  }
  if (layoutType === LayoutType.SidePanel) {
    return /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexDirection: "column",
      gap: "400",
      justifyContent: "center",
      marginBlockEnd: "500",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h1",
        textAlign: "center",
        typography: "heading-600",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: title
        })
      }), /*#__PURE__*/_jsx(Text, {
        textAlign: "center",
        typography: "body-200",
        children: /*#__PURE__*/_jsx(OptionalFormattedMessage, {
          message: getSubtitle()
        })
      })]
    });
  }
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    marginInline: "auto",
    children: [/*#__PURE__*/_jsx(StyledH1, {
      isEmbedded: isEmbedded,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: title
      })
    }), /*#__PURE__*/_jsx(Text, {
      marginBlockEnd: isEmbedded ? '400' : undefined,
      textAlign: "center",
      typography: "body-200",
      children: /*#__PURE__*/_jsx(OptionalFormattedMessage, {
        message: getSubtitle()
      })
    })]
  });
};